export const titleI = [
  {
    label: 'Skills Training',
    value: 'Skills Training',
  },
  {
    label: 'Employment',
    value: 'Employment',
  },
  {
    label: 'Work Readiness/Workshops',
    value: 'Work Readiness/Workshops',
  },
  {
    label: 'Job Coaching',
    value: 'Job Coaching',
  },
  {
    label: 'Youth Programs (Ages 18-24)',
    value: 'Youth Programs (Ages 18-24)',
  },
]

export const titleII = [
  {
    label: 'English as a Second Language (ESL)',
    value: 'English as a Second Language (ESL)',
  },
  {
    label: 'High School Equivalency (HSE) or General Education Development (GED)',
    value: 'High School Equivalency (HSE) or General Education Development (GED)',
  },
  {
    label: 'Citizenship Classes',
    value: 'Citizenship Classes',
  },
  {
    label: 'Bridge Training Programs',
    value: 'Bridge Training Programs',
  },
]

export const titleIII = [
  {
    label: 'Job Coaching',
    value: 'Job Coaching',
  },
  {
    label: 'Work Readiness Workshops',
    value: 'Work Readiness Workshops',
  },
  {
    label: 'Employment',
    value: 'Employment',
  },
  {
    label: 'Unemployment Insurance',
    value: 'Unemployment Insurance',
  },
  {
    label: 'Veterans Services',
    value: 'Veterans Services',
  },
]

export const titleIV = [
  {
    label: 'Employment',
    value: 'Employment',
  },
  {
    label: 'Training',
    value: 'Training',
  },
  {
    label: 'Supportive Home Services',
    value: 'Supportive Home Services',
  },
  {
    label: 'Services for Child(ren) with Disability',
    value: 'Services for Child(ren) with Disability',
  },
  {
    label: 'Social Security Disability Insurance (SSDI)',
    value: 'Social Security Disability Insurance (SSDI)',
  },
  {
    label: 'Supplemental Social Security Income (SSI)',
    value: 'Supplemental Social Security Income (SSI)',
  },
  {
    label: 'Specialized Services: Hispanic or Latino',
    value: 'Specialized Services: Hispanic or Latino',
  },
  {
    label: 'Specialized Services: Deaf or Hard of Hearing',
    value: 'Specialized Services: Deaf or Hard of Hearing',
  },
  {
    label: 'Specialized Services: Blind or Visually Impaired',
    value: 'Specialized Services: Blind or Visually Impaired',
  },
]

export const IDHSReferral = [
  {
    label: 'Supplemental Nutrition Assistance Program (SNAP)',
    value: 'Supplemental Nutrition Assistance Program (SNAP)',
  },
  {
    label: 'Temporary Assistance for Needy Families (TANF)',
    value: 'Temporary Assistance for Needy Families (TANF)',
  },
  {
    label: 'Supportive Services',
    value: 'Supportive Services',
  },
  {
    label: 'Medical Coverage/Benefits',
    value: 'Medical Coverage/Benefits',
  },
]
